export const LinkButton = {
    textDecoration: "underline",
    background: "none",
    color: "primary.main",
    cursor: "pointer",
    padding: 0,
    paddingLeft: 1,
    minWidth: "auto",
    fontWeight: "normal",
    boxShadow: "none",
    fontSize: '12px',
    "&:hover": {
        background: "none",
        textDecoration: "underline",
    },
    "&:disabled": {
        color: "gray",
        cursor: "not-allowed",
    },
};
